import React, { useEffect, useState } from 'react'
import './branch-area.scss'
import SinglePage from '../../components/common/page/SinglePage'
import TableFilter from '../../components/common/table-filter/TableFilter'
import { BiLoaderAlt } from 'react-icons/bi'
import { FaPlus } from 'react-icons/fa'
import Modal from '../../components/common/modal/Modal'
import CUBranchArea from '../../components/user/add-branch-area/CUBranchArea'
import { customerAxios } from '../../config/axios'
import toast from 'react-hot-toast'
import SpinWithMessage from '../../components/common/spinners/SpinWithMessage'
import { GrEdit } from 'react-icons/gr'
import { BsTrash3 } from 'react-icons/bs'


const BranchArea = () => {
    const [modal, setModal] = useState({ status: false })
    const [data, setData] = useState([])
    const [loading, setLoading] = useState('fetch')

    const openCUPost = () => {
        setModal({ status: true, title: "ADD AREA", content: <CUBranchArea setModal={setModal} setData={setData} /> })
    }

    const handleDelete = (city_id) => {
        const ask = window.confirm('Are you delete this area ?')
        if (ask) {
            setLoading('delete' + city_id)
            customerAxios.delete(`/l/area?city_id=${city_id}`).then(() => {
                setData((state) => state?.filter((area) => area.city_id !== city_id))
                setLoading('')
            }).catch((error) => {
                setLoading('')
                toast.error(error?.message)
            })
        }
    }

    useEffect(() => {
        setLoading('fetch')
        customerAxios.get('/l/area').then((response) => {
            setData(response.data)
            setLoading('')
        }).catch((error) => {
            setLoading('')
            toast.error(error?.message)
        })
    }, [])

    return (
        <div className="post-office-page-div">
            <Modal modal={modal} setModal={setModal} />
            <SinglePage titleArray={['Branch Area']}>
                {loading === 'fetch'
                    ? <SpinWithMessage />
                    : <TableFilter topRight={<button className='add-button' onClick={() => openCUPost()}><FaPlus /> Area</button>}>
                        <table>
                            <thead>
                                <tr>
                                    <th>City</th>
                                    <th>Post offices</th>
                                    <th>Pin Codes</th>
                                    <th>Area access</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.map((area) => {
                                    return <tr>
                                        <td>{area?.city_name}</td>
                                        <td>{area?.post_offices?.map((post) => <>{post} <br></br></>)}</td>
                                        <td>{area?.pin_codes?.map((pin) => <>{pin} <br></br></>)}</td>
                                        <td>{area?.service && 'Service'} {area?.service && area?.installation && ','} {area?.installation && 'Installation'}</td>
                                        <td>
                                            <div className='button-div'>
                                                <button onClick={() => setModal({
                                                    status: true,
                                                    content: <CUBranchArea currentData={area} setData={setData} setModal={setModal} />,
                                                    title: 'UPDATE AREA'
                                                })}><GrEdit /></button>
                                                <button onClick={() => handleDelete(area?.city_id)}>
                                                    {loading === `delete${area?.city_id}` ? <span className='loading-icon'><BiLoaderAlt /></span> : <BsTrash3 />}
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </TableFilter>
                }
            </SinglePage>
        </div>
    )
}

export default BranchArea